export enum ScheduleLeadTime {
  H24 = 24,
  H48 = 48,
  H72 = 72,
}
